import React, { Component, Fragment } from "react"
import styled from "react-emotion"
import { direction as directionContext } from "features/editor/ContextProviders"
import { boolean } from "../../attributes/items/primitives"
import DefineAction from "../../actions/DefineAction"
import { runInThisContext } from "vm"

class ModalBlockType extends Component {
    state = {
        show: false,
        default: null,
    }

    constructor(props) {
        super(props)
        this.state.show = props.config.attributes.showByDefault
        this.state.default = props.config.attributes.showByDefault
    }

    componentWillReceiveProps(newProps) {
        if (newProps.config.attributes.showByDefault !== this.state.default) {
            this.setState({
                show: newProps.config.attributes.showByDefault,
                default: newProps.config.attributes.showByDefault,
            })
        }
    }

    toggleVisible = () => {
        return new Promise((resolve, reject) => this.setState({ show: !this.state.show }, resolve))
    }
    show = () => {
        return new Promise((resolve, reject) => this.setState({ show: true }, resolve))
    }
    hide = () => {
        return new Promise((resolve, reject) => this.setState({ show: false }, resolve))
    }

    render() {
        const showModal = this.state.show
        const { Wrapper } = this.props
        return (
            <Fragment>
                {showModal ? (
                    <ModalCover
                        onClick={this.hide}
                        showBackdrop={this.props.config.attributes.showBackdrop}
                        isEditing={this.props.context.editor.isEditing}
                    >
                        <Wrapper {...this.props}>
                            {({ attrs, computedStyle, evaluateFormulas }) => {
                                return (
                                    <div
                                        style={{ ...computedStyle, width: "100%", height: "100%" }}
                                    >
                                        {showModal}
                                        <directionContext.Provider value="column">
                                            <div className="display-flex flex-column position-relative drop-here">
                                                {this.props.childBlocks.length === 0 ? (
                                                    this.props.renderDroppable(null)
                                                ) : (
                                                    <Fragment>
                                                        {this.props.renderDroppable(
                                                            null,
                                                            this.props.childBlocks.length
                                                        )}
                                                        {this.props.utils.renderChildren(
                                                            this.props.childBlocks
                                                        )}
                                                    </Fragment>
                                                )}
                                            </div>
                                        </directionContext.Provider>
                                    </div>
                                )
                            }}
                        </Wrapper>
                    </ModalCover>
                ) : (
                    this.props.context.editor.isEditing && (
                        <Wrapper {...this.props} style={{}} noStyles>
                            {() => (
                                <ModalPlaceholder onClick={this.show}>
                                    {this.props.id}
                                </ModalPlaceholder>
                            )}
                        </Wrapper>
                    )
                )}
                <DefineAction name={this.props.id + ": Show Modal"} action={this.show} />
                <DefineAction name={this.props.id + ": Hide Modal"} action={this.hide} />
                <DefineAction name={this.props.id + ": Toggle Modal"} action={this.toggle} />
            </Fragment>
        )
    }
}

const ModalCover = styled("div")`
    background-color: rgba(0, 0, 0, ${props => (props.showBackdrop ? "0.5" : 0)});
    transition: opacity 0.15s linear;
    position: fixed;
    top: ${props => (props.isEditing ? "50px" : 0)};
    right: ${props => (props.isEditing ? "250px" : "0px")};
    bottom: ${props => (props.isEditing ? "30px" : "0px")};
    left: ${props => (props.isEditing ? "40px" : 0)};
    z-index: 1;
    overflow: hidden;
    outline: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ModalPlaceholder = styled("div")`
    height: 50px;
    width: 50px;
    border: 1px solid rgba(10, 200, 10, 1);
    background: rgba(10, 200, 10, 0.2);
    color: rgba(10, 200, 10, 0.5);
    overflow: hidden;
    font-size: 10px;
    font-family: "Avenir-Next";
`

ModalBlockType.propTypes = {}

ModalBlockType.attributes = [
    boolean({ field: "showByDefault", label: "Show by default" }),
    boolean({ field: "showBackdrop", label: "Show Backdrop" }),
]

export default ModalBlockType



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/layout/ModalBlock.js